import { render, staticRenderFns } from "./details-introduce.vue?vue&type=template&id=7f3e1867&scoped=true"
import script from "./details-introduce.vue?vue&type=script&lang=js"
export * from "./details-introduce.vue?vue&type=script&lang=js"
import style0 from "./details-introduce.vue?vue&type=style&index=0&id=7f3e1867&prod&scoped=true&lang=css"
import style1 from "./details-introduce.vue?vue&type=style&index=1&id=7f3e1867&prod&lang=css"
import style2 from "./details-introduce.vue?vue&type=style&index=2&id=7f3e1867&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3e1867",
  null
  
)

export default component.exports